import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useSessionStore from '../../store/session';
import RouteUrls from '../enums/RouteUrls';

/**
 * ProtectedRoute
 * @param props Object
 * @param props.children Component to navigate to
 * @param props.route Route to check
 * @returns Redirects to LoginPage if the user isn't authentified
 */
function ProtectedRoute({ children, route }) {

    // Store
    const session = useSessionStore(s => s.session);

    // Render
    if (!session) {
        // session is not authenticated
        return <Navigate to={RouteUrls.LOGIN.url} />;
    }

    // Check if the user has the required permission
    // Route can have a hasPermissions function to check if the user has the required permissions
    if (route?.hasPermissions && !route?.hasPermissions(session?.permissions)) {
        return <Navigate to={RouteUrls.HOME.url} />;
    }
    return children;
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    route: PropTypes.object
};

export default ProtectedRoute;